import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { Notification } from 'element-ui';
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

axios.interceptors.request.use(
    config => {

                store.commit('setHttpRequestCount', 1)
        console.log('request中的进程：', store.state.httpRequestCount)

                config.headers['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')

        return config

    }
)

axios.interceptors.response.use(
    config => {

                store.commit('setHttpRequestCount', -1)
        console.log('response中的进程：', store.state.httpRequestCount)

                                        
        return config;

    },
    error => {
        
                store.commit('setHttpRequestCount', -1)
        console.log('error中的进程', store.state.httpRequestCount)

                if (error.response.status == 401) {
            sessionStorage.setItem('pathTo', router.history.current.fullPath)
            router.push('/auth/login')
        }
        
                if (error.response.status != 401) {
            Notification.error({ title: '提示', dangerouslyUseHTMLString: true, message: error.response.data, duration: 2000 })
        }

    }
)

Vue.prototype.$http = axios